<template>
  <div id="leaderHallEdit">
    <div class="dialog">
      <span class="cls" @click="closeDialog"></span>

      <div class="paper">
        <div class="header">
          <h1>🛠️ 명예의 전당 관리</h1>
          <span @click="closeDialog"><i class="ph-bold ph-x"></i></span>
        </div>

        <!-- 탭 -->
        <div class="edit-tabs">
          <button :class="{ active: editTab === 'score' }" @click="editTab = 'score'">
            <i class="ph ph-chart-bar"></i> 점수 입력
          </button>
          <button :class="{ active: editTab === 'award' }" @click="editTab = 'award'">
            <i class="ph ph-medal"></i> 어워드 수여
          </button>
          <button :class="{ active: editTab === 'guinness' }" @click="editTab = 'guinness'">
            <i class="ph ph-trophy"></i> 기네스 등록
          </button>
        </div>

        <!-- 점수 입력 -->
        <div class="edit-content" v-if="editTab === 'score'">
          <div class="score-layout">
            <!-- 좌측: 멤버 목록 -->
            <div class="member-panel">
              <div class="panel-header">
                <h3>멤버 선택</h3>
                <span class="count">{{ filteredMembers.length }}명</span>
              </div>
              
              <div class="filter-bar">
                <input 
                  type="text" 
                  v-model="searchKeyword" 
                  placeholder="이름 검색..."
                  class="search-input"
                />
                <select v-model="sortBy" class="sort-select">
                  <option value="name">이름순</option>
                  <option value="level">레벨순</option>
                  <option value="recent">최근등록순</option>
                </select>
              </div>

              <ul class="member-list">
                <li 
                  v-for="member in filteredMembers" 
                  :key="member.mb_id"
                  :class="{ active: selectedMember?.mb_id === member.mb_id }"
                  @click="selectMember(member)"
                >
                  <img :src="member.image || '/imgs/unknow_user.png'" />
                  <div class="member-info">
                    <span class="name">{{ member.name }}</span>
                    <span class="level">Lv.{{ member.level }}</span>
                  </div>
                  <i class="ph ph-check" v-if="hasSavedScore(member.mb_id)"></i>
                </li>
              </ul>
            </div>

            <!-- 우측: 점수 입력 폼 -->
            <div class="score-panel">
              <div class="panel-header">
                <h3>점수 입력</h3>
                <div class="month-selector">
                  <label>대상 월</label>
                  <input type="month" v-model="scoreMonth" @change="fetchScores" />
                </div>
              </div>

              <div class="score-form" v-if="selectedMember">
                <div class="selected-member">
                  <img :src="selectedMember.image || '/imgs/unknow_user.png'" />
                  <div>
                    <h2>{{ selectedMember.name }}</h2>
                    <span>Lv.{{ selectedMember.level }}</span>
                  </div>
                </div>

                <div class="score-inputs">
                  <div class="score-item">
                    <label><i class="ph ph-chart-line-up"></i> 실적점수</label>
                    <input type="number" v-model.number="scoreInput.sales" placeholder="0" />
                  </div>
                  <div class="score-item">
                    <label><i class="ph ph-lightning"></i> 활동점수</label>
                    <input type="number" v-model.number="scoreInput.activity" placeholder="0" />
                  </div>
                  <div class="score-item">
                    <label><i class="ph ph-star"></i> 평가점수</label>
                    <input type="number" v-model.number="scoreInput.eval" placeholder="0" />
                  </div>
                </div>

                <button class="save-btn-lg" @click="saveScore" :disabled="isSaving">
                  <i class="ph ph-check"></i>
                  {{ isSaving ? '저장 중...' : '저장' }}
                </button>
              </div>

              <div class="empty-state" v-else>
                <i class="ph ph-user-list"></i>
                <p>좌측에서 멤버를 선택해주세요</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 어워드 수여 -->
        <div class="edit-content" v-if="editTab === 'award'">
          <div class="award-layout">
            <!-- 좌측: 멤버 선택 -->
            <div class="member-panel">
              <div class="panel-header">
                <h3>수상자 선택</h3>
              </div>
              
              <div class="filter-bar">
                <input 
                  type="text" 
                  v-model="searchKeyword" 
                  placeholder="이름 검색..."
                  class="search-input"
                />
              </div>

              <ul class="member-list">
                <li 
                  v-for="member in filteredMembers" 
                  :key="member.mb_id"
                  :class="{ active: awardForm.mbId === member.mb_id }"
                  @click="awardForm.mbId = member.mb_id"
                >
                  <img :src="member.image || '/imgs/unknow_user.png'" />
                  <div class="member-info">
                    <span class="name">{{ member.name }}</span>
                    <span class="level">Lv.{{ member.level }}</span>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 우측: 어워드 폼 -->
            <div class="award-panel">
              <div class="panel-header">
                <h3>어워드 수여</h3>
              </div>

              <div class="award-form">
                <div class="selected-member" v-if="selectedAwardMember">
                  <img :src="selectedAwardMember.image || '/imgs/unknow_user.png'" />
                  <div>
                    <h2>{{ selectedAwardMember.name }}</h2>
                    <span>Lv.{{ selectedAwardMember.level }}</span>
                  </div>
                </div>
                <div class="empty-member" v-else>
                  <p>좌측에서 수상자를 선택해주세요</p>
                </div>

                <div class="form-grid">
                  <div class="form-row">
                    <label>수상 월</label>
                    <input type="month" v-model="awardMonth" />
                  </div>
                  <div class="form-row">
                    <label>어워드 종류</label>
                    <select v-model="awardForm.awardType">
                      <option value="">선택</option>
                      <option value="MVP">🏅 MVP</option>
                      <option value="GOLD">🥇 Gold Performer</option>
                      <option value="SILVER">🥈 Silver Performer</option>
                      <option value="BRONZE">🥉 Bronze Performer</option>
                      <option value="EXEMPLARY">⚡ Exemplary</option>
                      <option value="SMILE">😊 Smile</option>
                    </select>
                  </div>
                  <div class="form-row full">
                    <label>비고</label>
                    <input type="text" v-model="awardForm.description" placeholder="수상 사유 (선택)" />
                  </div>
                </div>

                <button class="submit-btn" @click="saveAward" :disabled="isSaving || !awardForm.mbId">
                  <i class="ph ph-medal"></i> 어워드 수여
                </button>
              </div>

              <!-- 최근 수여 목록 -->
              <div class="recent-list">
                <h3>최근 수여 내역</h3>
                <ul>
                  <li v-for="award in recentAwards" :key="award.idx">
                    <span class="type">{{ getAwardLabel(award.award_type) }}</span>
                    <span class="name">{{ award.mb_name }}</span>
                    <span class="date">{{ formatDate(award.award_date) }}</span>
                    <button class="delete-btn" @click="deleteAward(award.idx)">
                      <i class="ph ph-trash"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 기네스 등록 -->
        <div class="edit-content" v-if="editTab === 'guinness'">
          <div class="guinness-layout">
            <!-- 좌측: 멤버 선택 -->
            <div class="member-panel">
              <div class="panel-header">
                <h3>기록 보유자 선택</h3>
              </div>
              
              <div class="filter-bar">
                <input 
                  type="text" 
                  v-model="searchKeyword" 
                  placeholder="이름 검색..."
                  class="search-input"
                />
              </div>

              <ul class="member-list">
                <li 
                  v-for="member in filteredMembers" 
                  :key="member.mb_id"
                  :class="{ active: guinnessForm.mbId === member.mb_id }"
                  @click="guinnessForm.mbId = member.mb_id"
                >
                  <img :src="member.image || '/imgs/unknow_user.png'" />
                  <div class="member-info">
                    <span class="name">{{ member.name }}</span>
                    <span class="level">Lv.{{ member.level }}</span>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 우측: 기네스 폼 -->
            <div class="guinness-panel">
              <div class="panel-header">
                <h3>기네스 등록</h3>
              </div>

              <div class="guinness-form">
                <div class="selected-member" v-if="selectedGuinnessMember">
                  <img :src="selectedGuinnessMember.image || '/imgs/unknow_user.png'" />
                  <div>
                    <h2>{{ selectedGuinnessMember.name }}</h2>
                    <span>Lv.{{ selectedGuinnessMember.level }}</span>
                  </div>
                </div>
                <div class="empty-member" v-else>
                  <p>좌측에서 기록 보유자를 선택해주세요</p>
                </div>

                <div class="form-grid">
                  <div class="form-row">
                    <label>기록 종류</label>
                    <select v-model="guinnessForm.recordType">
                      <option value="">선택</option>
                      <option value="SALES">💰 최고 매출</option>
                      <option value="CONTRACTS">📝 최다 계약</option>
                      <option value="CONSULTATIONS">💬 최다 상담</option>
                      <option value="SALARY">💵 최대 급여</option>
                      <option value="RECRUITING">👥 최다 리쿠르팅</option>
                    </select>
                  </div>
                  <div class="form-row">
                    <label>기록 수치</label>
                    <input type="number" v-model.number="guinnessForm.recordValue" placeholder="0" />
                  </div>
                  <div class="form-row">
                    <label>기록 일자</label>
                    <input type="date" v-model="guinnessForm.recordDate" />
                  </div>
                  <div class="form-row full">
                    <label>비고</label>
                    <input type="text" v-model="guinnessForm.description" placeholder="기록 설명 (선택)" />
                  </div>
                </div>

                <button class="submit-btn" @click="saveGuinness" :disabled="isSaving || !guinnessForm.mbId">
                  <i class="ph ph-trophy"></i> 기네스 등록
                </button>
              </div>

              <!-- 현재 기네스 목록 -->
              <div class="recent-list">
                <h3>현재 기네스 기록</h3>
                <ul>
                  <li v-for="record in currentGuinness" :key="record.idx">
                    <span class="type">{{ getGuinnessLabel(record.record_type) }}</span>
                    <span class="name">{{ record.mb_name }}</span>
                    <span class="value">{{ Number(record.record_value).toLocaleString() }}</span>
                    <button class="delete-btn" @click="deleteGuinness(record.idx)">
                      <i class="ph ph-trash"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, inject } from 'vue';
import { useBackButton } from '@/utils/useBackBtn';

export default {
  name: 'dialog_leaderHallEdit',
  emits: ['close'],
  props: {
    oth_showLeaderHallEdit: Function,
  },
  setup(props, { emit }) {
    const sql_query = inject('sql_query');

    const editTab = ref('score');
    const isSaving = ref(false);
    const searchKeyword = ref('');
    const sortBy = ref('name');
    const allMembers = ref([]);
    const savedScores = ref([]); // 이미 저장된 점수 목록
    const recentAwards = ref([]);
    const currentGuinness = ref([]);
    const selectedMember = ref(null);

    // 현재 월 (YYYY-MM 형식)
    const now = new Date();
    const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    
    const scoreMonth = ref(currentMonth);
    const awardMonth = ref(currentMonth);

    // 점수용 날짜 (해당 월 1일)
    const scoreDate = computed(() => `${scoreMonth.value}-01`);
    const awardDate = computed(() => `${awardMonth.value}-01`);

    // 점수 입력
    const scoreInput = ref({
      sales: 0,
      activity: 0,
      eval: 0,
    });

    const awardForm = ref({
      awardType: '',
      mbId: '',
      description: '',
    });

    const guinnessForm = ref({
      recordType: '',
      mbId: '',
      recordValue: 0,
      recordDate: now.toISOString().slice(0, 10),
      description: '',
    });

    // 필터링 + 정렬된 멤버 목록
    // filteredMembers 수정
    const filteredMembers = computed(() => {
      let list = [...allMembers.value];
      
      // 검색 필터
      if (searchKeyword.value) {
        list = list.filter(m => m.name?.includes(searchKeyword.value));
      }
      
      // 정렬
      if (sortBy.value === 'name') {
        list.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
      } else if (sortBy.value === 'level') {
        list.sort((a, b) => (b.level || 0) - (a.level || 0));
      } else if (sortBy.value === 'recent') {
        list.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
      }
      
      return list;
    });

    // 선택된 어워드 멤버
    const selectedAwardMember = computed(() => {
      return allMembers.value.find(m => m.mb_id === awardForm.value.mbId);
    });

    // 선택된 기네스 멤버
    const selectedGuinnessMember = computed(() => {
      return allMembers.value.find(m => m.mb_id === guinnessForm.value.mbId);
    });

    // 이미 저장된 점수가 있는지 확인
    function hasSavedScore(mbId) {
      return savedScores.value.some(s => s.mb_id === mbId);
    }

    // 멤버 선택
    function selectMember(member) {
      selectedMember.value = member;
      
      // 기존 점수 불러오기
      const existing = savedScores.value.find(s => s.mb_id === member.mb_id);
      if (existing) {
        scoreInput.value = {
          sales: existing.sales_score || 0,
          activity: existing.activity_score || 0,
          eval: existing.eval_score || 0,
        };
      } else {
        scoreInput.value = { sales: 0, activity: 0, eval: 0 };
      }
    }

    async function fetchMembers() {
      const sql = `SELECT mb_id, name, image, level, created_at FROM member ORDER BY name`;
      const result = await sql_query(sql);
      allMembers.value = Array.isArray(result) ? result : [];
    }

    async function fetchScores() {
      if (!scoreDate.value) return;
      
      const sql = `SELECT * FROM member_scores WHERE score_date = '${scoreDate.value}'`;
      const result = await sql_query(sql);
      savedScores.value = Array.isArray(result) ? result : [];
      
      // 현재 선택된 멤버의 점수도 업데이트
      if (selectedMember.value) {
        selectMember(selectedMember.value);
      }
    }

    async function fetchRecentAwards() {
      const sql = `
        SELECT ma.*, m.name as mb_name
        FROM member_awards ma
        JOIN member m ON ma.mb_id = m.mb_id
        ORDER BY ma.created_at DESC
        LIMIT 20
      `;
      const result = await sql_query(sql);
      recentAwards.value = Array.isArray(result) ? result : [];
    }

    async function fetchCurrentGuinness() {
      const sql = `
        SELECT mg.*, m.name as mb_name
        FROM member_guinness mg
        JOIN member m ON mg.mb_id = m.mb_id
        ORDER BY mg.record_type
      `;
      const result = await sql_query(sql);
      currentGuinness.value = Array.isArray(result) ? result : [];
    }

    async function saveScore() {
      if (!selectedMember.value) {
        alert('멤버를 선택해주세요.');
        return;
      }
      
      isSaving.value = true;
      try {
        const sql = `
          INSERT INTO member_scores (mb_id, score_date, sales_score, activity_score, eval_score)
          VALUES ('${selectedMember.value.mb_id}', '${scoreDate.value}', 
                  ${scoreInput.value.sales || 0}, ${scoreInput.value.activity || 0}, ${scoreInput.value.eval || 0})
          ON DUPLICATE KEY UPDATE
            sales_score = ${scoreInput.value.sales || 0},
            activity_score = ${scoreInput.value.activity || 0},
            eval_score = ${scoreInput.value.eval || 0}
        `;
        await sql_query(sql);
        alert('저장되었습니다.');
        await fetchScores();
      } catch (e) {
        alert('저장 실패');
      } finally {
        isSaving.value = false;
      }
    }

    async function saveAward() {
      if (!awardForm.value.awardType || !awardForm.value.mbId) {
        alert('어워드 종류와 수상자를 선택해주세요.');
        return;
      }
      isSaving.value = true;
      try {
        const sql = `
          INSERT INTO member_awards (mb_id, award_type, award_date, description)
          VALUES ('${awardForm.value.mbId}', '${awardForm.value.awardType}', 
                  '${awardDate.value}', '${awardForm.value.description || ''}')
        `;
        await sql_query(sql);
        alert('어워드가 수여되었습니다.');
        awardForm.value.awardType = '';
        awardForm.value.mbId = '';
        awardForm.value.description = '';
        fetchRecentAwards();
      } catch (e) {
        alert('저장 실패');
      } finally {
        isSaving.value = false;
      }
    }

    async function deleteAward(idx) {
      if (!confirm('삭제하시겠습니까?')) return;
      await sql_query(`DELETE FROM member_awards WHERE idx = ${idx}`);
      fetchRecentAwards();
    }

    async function saveGuinness() {
      if (!guinnessForm.value.recordType || !guinnessForm.value.mbId) {
        alert('기록 종류와 보유자를 선택해주세요.');
        return;
      }
      isSaving.value = true;
      try {
        await sql_query(`DELETE FROM member_guinness WHERE record_type = '${guinnessForm.value.recordType}'`);
        
        const sql = `
          INSERT INTO member_guinness (mb_id, record_type, record_value, record_date, description)
          VALUES ('${guinnessForm.value.mbId}', '${guinnessForm.value.recordType}', 
                  ${guinnessForm.value.recordValue}, '${guinnessForm.value.recordDate}',
                  '${guinnessForm.value.description || ''}')
        `;
        await sql_query(sql);
        alert('기네스 기록이 등록되었습니다.');
        guinnessForm.value.recordType = '';
        guinnessForm.value.mbId = '';
        guinnessForm.value.recordValue = 0;
        guinnessForm.value.description = '';
        fetchCurrentGuinness();
      } catch (e) {
        alert('저장 실패');
      } finally {
        isSaving.value = false;
      }
    }

    async function deleteGuinness(idx) {
      if (!confirm('삭제하시겠습니까?')) return;
      await sql_query(`DELETE FROM member_guinness WHERE idx = ${idx}`);
      fetchCurrentGuinness();
    }

    function formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return `${d.getFullYear()}년 ${d.getMonth() + 1}월`;
    }

    function getAwardLabel(type) {
      const map = {
        MVP: '🏅 MVP',
        GOLD: '🥇 Gold',
        SILVER: '🥈 Silver',
        BRONZE: '🥉 Bronze',
        EXEMPLARY: '⚡ Exemplary',
        SMILE: '😊 Smile',
      };
      return map[type] || type;
    }

    function getGuinnessLabel(type) {
      const map = {
        SALES: '💰 최고 매출',
        CONTRACTS: '📝 최다 계약',
        CONSULTATIONS: '💬 최다 상담',
        SALARY: '💵 최대 급여',
        RECRUITING: '👥 최다 리쿠르팅',
      };
      return map[type] || type;
    }

    function closeDialog() {
      if (props.oth_showLeaderHallEdit) {
        props.oth_showLeaderHallEdit(false);
      }
      emit('close');
    }

    useBackButton(() => closeDialog());

    onMounted(() => {
      fetchMembers();
      fetchScores();
      fetchRecentAwards();
      fetchCurrentGuinness();
    });

    return {
      editTab,
      isSaving,
      searchKeyword,
      sortBy,
      allMembers,
      filteredMembers,
      savedScores,
      selectedMember,
      selectedAwardMember,
      selectedGuinnessMember,
      recentAwards,
      currentGuinness,
      scoreMonth,
      awardMonth,
      scoreInput,
      awardForm,
      guinnessForm,
      hasSavedScore,
      selectMember,
      saveScore,
      saveAward,
      deleteAward,
      saveGuinness,
      deleteGuinness,
      formatDate,
      getAwardLabel,
      getGuinnessLabel,
      closeDialog,
      fetchScores,
    };
  }
}
</script>

<style scoped>
#leaderHallEdit {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(8px);
}

.dialog {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cls {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.paper {
  width: 95%;
  max-width: 1100px;
  height: 90%;
  max-height: 800px;
  background: var(--color-background);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--color-background-light);
}

.header h1 {
  margin: 0;
  font-size: var(--font-size-xl);
}

.header span {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: var(--radius-md);
}

.header span:hover {
  background: var(--color-background-light);
}

.edit-tabs {
  display: flex;
  gap: 8px;
  padding: 16px 24px;
  border-bottom: 1px solid var(--color-background-light);
}

.edit-tabs button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border: 2px solid transparent;
  border-radius: var(--radius-md);
  background: var(--color-surface-reverse);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all 0.2s;
}

.edit-tabs button.active {
  border-color: var(--color-brand);
  background: var(--color-brand-light);
  color: var(--color-brand);
}

.edit-content {
  flex: 1;
  overflow: hidden;
  padding: 0;
}

/* 2컬럼 레이아웃 */
.score-layout,
.award-layout,
.guinness-layout {
  display: flex;
  height: 100%;
}

/* 멤버 패널 (좌측) */
.member-panel {
  width: 280px;
  border-right: 1px solid var(--color-background-light);
  display: flex;
  flex-direction: column;
  background: var(--color-surface-reverse);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid var(--color-background-light);
}

.panel-header h3 {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
}

.panel-header .count {
  font-size: var(--font-size-sm);
  color: var(--color-brand);
  font-weight: var(--font-weight-bold);
}

.filter-bar {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid var(--color-background-light);
  box-sizing:border-box;
}

.search-input {
  flex: 1;
  min-width: 0; /* 이거 추가! flexbox 오버플로우 방지 */
  padding: 10px 12px;
  border: 1px solid var(--color-background-light);
  border-radius: var(--radius-md);
  background: var(--color-background);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  box-sizing: border-box;
}

.sort-select {
  flex-shrink: 0; /* 줄어들지 않게 */
  padding: 10px 12px;
  border: 1px solid var(--color-background-light);
  border-radius: var(--radius-md);
  background: var(--color-background);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  box-sizing: border-box;
}

.member-list {
  flex: 1;
  overflow-y: auto;
  list-style: none;
  padding: 8px;
  margin: 0;
}

.member-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.15s;
}

.member-list li:hover {
  background: var(--color-background);
}

.member-list li.active {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.member-list li img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.member-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.member-info .name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}

.member-info .level {
  font-size: var(--font-size-xs);
  opacity: 0.7;
}

.member-list li .ph-check {
  color: var(--color-special-point);
  font-size: var(--font-size-lg);
}

.member-list li.active .ph-check {
  color: var(--color-text-black);
}

/* 우측 패널 */
.score-panel,
.award-panel,
.guinness-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 24px;
}

.month-selector {
  display: flex;
  align-items: center;
  gap: 8px;
}

.month-selector label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.month-selector input {
  padding: 8px 12px;
  border: 1px solid var(--color-background-light);
  border-radius: var(--radius-md);
  background: var(--color-surface-reverse);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
}

.score-form,
.award-form,
.guinness-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.selected-member {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--color-surface-reverse);
  border-radius: var(--radius-lg);
}

.selected-member img {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--color-brand);
}

.selected-member h2 {
  margin: 0;
  font-size: var(--font-size-xl);
}

.selected-member span {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.empty-member {
  padding: 20px;
  background: var(--color-surface-reverse);
  border-radius: var(--radius-lg);
  text-align: center;
  color: var(--color-text-secondary);
}

.score-inputs {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.score-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.score-item label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  width: 100px;
  flex-shrink: 0;
}

.score-item input {
  flex: 1;
  padding: 14px 16px;
  border: 2px solid var(--color-background-light);
  border-radius: var(--radius-md);
  background: var(--color-surface-reverse);
  color: var(--color-text-primary);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  text-align: center;
  box-sizing: border-box;
}

.score-item input:focus {
  outline: none;
  border-color: var(--color-brand);
}

.save-btn-lg {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  border: none;
  border-radius: var(--radius-md);
  background: var(--color-brand);
  color: var(--color-text-black);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all 0.2s;
}

.save-btn-lg:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 165, 0, 0.4);
}

.save-btn-lg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: var(--color-text-secondary);
}

.empty-state i {
  font-size: 64px;
  opacity: 0.3;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-row.full {
  grid-column: span 2;
}

.form-row label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
}

.form-row input,
.form-row select {
  padding: 12px 16px;
  border: 2px solid var(--color-background-light);
  border-radius: var(--radius-md);
  background: var(--color-surface-reverse);
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
}

.form-row input:focus,
.form-row select:focus {
  outline: none;
  border-color: var(--color-brand);
}

.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 24px;
  border: none;
  border-radius: var(--radius-md);
  background: var(--color-brand);
  color: var(--color-text-black);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  align-self: flex-start;
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Recent List */
.recent-list {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid var(--color-background-light);
}

.recent-list h3 {
  font-size: var(--font-size-base);
  margin: 0 0 16px 0;
}

.recent-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recent-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--color-surface-reverse);
  border-radius: var(--radius-md);
}

.recent-list .type {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}

.recent-list .name {
  flex: 1;
}

.recent-list .date,
.recent-list .value {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.delete-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
}

.delete-btn:hover {
  background: var(--color-special-warning);
  color: white;
}

/* 태블릿 */
@media (max-width: 900px) {
  .member-panel {
    width: 220px;
  }

  .score-inputs {
    grid-template-columns: 1fr;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-row.full {
    grid-column: span 1;
  }
}

/* 모바일 */
@media (max-width: 600px) {
  .paper {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }

  .score-layout,
  .award-layout,
  .guinness-layout {
    flex-direction: column;
  }

  .member-panel {
    width: 100%;
    height: 200px;
    border-right: none;
    border-bottom: 1px solid var(--color-background-light);
  }

  .member-list {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 8px;
    gap: 8px;
  }

  .member-list li {
    flex-shrink: 0;
    flex-direction: column;
    width: 80px;
    padding: 12px 8px;
    text-align: center;
  }

  .member-list li img {
    width: 48px;
    height: 48px;
  }

  .member-info {
    align-items: center;
  }

  .filter-bar {
    display: flex;
    gap: 8px;
    padding: 12px;
    border-bottom: 1px solid var(--color-background-light);
    box-sizing: border-box;
  }

  .edit-tabs {
    overflow-x: auto;
    padding: 12px 16px;
  }

  .edit-tabs button {
    white-space: nowrap;
    padding: 8px 14px;
    font-size: var(--font-size-xs);
  }

  .score-panel,
  .award-panel,
  .guinness-panel {
    padding: 16px;
  }

  .selected-member {
    flex-direction: column;
    text-align: center;
  }
}
</style>